(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      // Only treat this as a Swiper if we actually have a .swiper container
      this.swiperContainer = this.querySelector('.products-carousel__slider.swiper');
      this.swiper = null;

      // From data-cards-size="{{ settings.product_card_size }}"
      this.cardsSize = this.dataset.cardsSize || 'default';

      this.breakpoints = {
        desktop: 990
      };

      this.mainSettings = null;
    }

    connectedCallback() {
      // If this section is "grid" layout (no .swiper), bail out gracefully
      if (!this.swiperContainer) return;

      this.initSwiper();
    }

    buildSettings() {
      const swiperNext = this.querySelector('.products-carousel__control-next');
      const swiperPrev = this.querySelector('.products-carousel__control-prev');

      // Tweak these if you want tighter/looser layouts
      const sizeCardSettings = {
        default: {
          slidesPerView: 1.4,   // show a bit of the next card on mobile
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 3.2,
              spaceBetween: 32
            }
          }
        },
        large: {
          slidesPerView: 1.2,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 2.8,
              spaceBetween: 32
            }
          }
        }
      };

      const sizeSettings =
        sizeCardSettings[this.cardsSize] || sizeCardSettings.default;

      this.mainSettings = {
        // Arrow buttons if not hidden
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev
        },

        // Slightly faster feel on arrow clicks
        speed: 450,

        // 🔑 Smooth gliding behavior
        freeMode: {
          enabled: true,
          momentum: true,
          momentumBounce: false,
          momentumVelocityRatio: 1.2, // higher = more “fling”
          sticky: false               // no snapping back to slides
        },

        grabCursor: true,
        resistanceRatio: 0.3,

        slidesPerView: sizeSettings.slidesPerView,
        spaceBetween: sizeSettings.spaceBetween,
        breakpoints: sizeSettings.breakpoints,

        // Optional, but helps if the section lives in tabs/hidden blocks
        observeParents: true,
        observer: true
      };
    }

    initSwiper() {
      if (!this.swiperContainer) return;

      this.buildSettings();

      this.swiper = new Swiper(this.swiperContainer, this.mainSettings);
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();